module.exports = __webpack_public_path__ + "static/picasso-head-trim-29749e5e02c6e576b1a896b13c1157df.webp";